import React from 'react'
import './SliderWrapper.css'

const SliderWrapper = ({ children }) => (
  <div className="slider-wrapper">
    {children}
  </div>
);

export default SliderWrapper;



// WEBPACK FOOTER //
// ./src/widgets/NetflixSlider/SliderWrapper.js